import { AUTH_TYPE } from '@typings/common/authorizationType';
import { User } from '@typings/setting/userType.interface';
import { atom, selector } from 'recoil';

export const currentUserIDState = atom<string | null | undefined>({
  key: 'currentUserID',
  default: '',
});

export const currentUserWalletState = atom<number | string | null | undefined>({
  key: 'currentUserWalletState',
  default: 0,
});

export const currentUserAuthTypeState = atom<string>({
  key: 'curretnUserAuthType',
  // 초기값은 비로그인. 로그인 후 LayoutWrapper 가 user doc 기반으로 갱신.
  default: AUTH_TYPE.ANONYMOUS,
});

export const currentUserDataState = atom<User | null | undefined>({
  key: 'currentUserDataState',
  default: undefined,
});

export const isMasterState = selector<boolean>({
  key: 'isMasterState',
  get: ({ get }) => {
    const currentUserType = get(currentUserAuthTypeState);
    return currentUserType === AUTH_TYPE.MASTER;
  },
});

export const isMemberState = selector<boolean>({
  key: 'isMemberState',
  get: ({ get }) => {
    const currentUserType = get(currentUserAuthTypeState);
    return currentUserType === AUTH_TYPE.MEMBER;
  },
});

export const isGuestState = selector<boolean>({
  key: 'isGuestState',
  get: ({ get }) => {
    const currentUserType = get(currentUserAuthTypeState);
    return currentUserType === AUTH_TYPE.GUEST;
  },
});

// 비로그인 여부 (Firebase Auth 가 익명으로 확정된 상태)
export const isAnonymousState = selector<boolean>({
  key: 'isAnonymousState',
  get: ({ get }) => {
    const currentUserType = get(currentUserAuthTypeState);
    return currentUserType === AUTH_TYPE.ANONYMOUS;
  },
});
// Firebase Auth가 최초 상태 확인을 완료했는지 여부 (onAuthStateChanged 첫 콜백 이후 true)
export const authInitializedState = atom<boolean>({
  key: 'authInitializedState',
  default: false,
});
